module.exports = __webpack_public_path__ + "static/media/527.09cc2275.png";